import React from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { MdDashboard } from "react-icons/md";

import SidebarSection from "./SidebarSection";
import { ADMIN_NAVBAR_OFFSET } from "../data/adminShellConfig";

export default function MobileSidebar({
  mobileOpen,
  pathname,
  visibleSections,
  onOpen,
  onClose,
}) {
  return (
    <>
      <button
        type="button"
        onClick={onOpen}
        className="fixed left-4 z-[70] flex h-12 w-12 items-center justify-center rounded-2xl border border-slate-200 bg-white/95 text-slate-800 shadow-xl backdrop-blur dark:border-slate-700 dark:bg-slate-900/95 dark:text-white lg:hidden"
        style={{ top: "104px" }}
        aria-label="Ouvrir le menu administrateur"
      >
        <FaBars />
      </button>

      {mobileOpen ? (
        <div className="fixed inset-0 z-[80] lg:hidden">
          <div
            className="absolute inset-0 bg-slate-950/60 backdrop-blur-sm"
            onClick={onClose}
          />

          <aside
            className="absolute left-0 w-[90vw] max-w-[380px] overflow-hidden border-r border-slate-200 bg-white shadow-2xl dark:border-slate-800 dark:bg-slate-950"
            style={{
              top: ADMIN_NAVBAR_OFFSET,
              height: `calc(100dvh - ${ADMIN_NAVBAR_OFFSET})`,
            }}
          >
            <div className="border-b border-slate-200 bg-gradient-to-br from-sky-50 via-white to-cyan-50 px-4 py-4 dark:border-slate-800 dark:from-slate-900 dark:via-slate-950 dark:to-sky-950/40">
              <div className="flex items-center justify-between gap-3">
                <div className="flex min-w-0 items-center gap-3">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-[#1277B9] to-cyan-400 text-xl text-white shadow-lg shadow-sky-500/25">
                    <MdDashboard />
                  </div>

                  <div className="min-w-0">
                    <p className="truncate text-sm font-bold text-slate-950 dark:text-white">
                      Menu administrateur
                    </p>
                    <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
                      Choisissez une rubrique à gérer
                    </p>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={onClose}
                  className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
                  aria-label="Fermer le menu"
                >
                  <FaTimes />
                </button>
              </div>
            </div>

            <div className="h-[calc(100%-81px)] overflow-y-auto px-2 pb-6">
              {visibleSections.map((section) => (
                <SidebarSection
                  key={section.label}
                  section={section}
                  pathname={pathname}
                  isCollapsed={false}
                  onNavigate={onClose}
                  mobile
                />
              ))}
            </div>
          </aside>
        </div>
      ) : null}
    </>
  );
}